import { NgModule } from '@angular/core';
import { PathLocationStrategy, LocationStrategy, CurrencyPipe } from '@angular/common';
import { initializeApp } from "firebase/app";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './demo/layout/app.layout.module';
import { LayoutModule } from './layout/layout.module';
import { environment } from 'src/environments/environment.prod';
import { ToastModule } from 'primeng/toast';
import { ToasterComponent } from './shared/components/toaster/toaster.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfimationDialogueComponent } from './shared/components/confimation-dialogue/confimation-dialogue.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePipe } from '@angular/common';
import { SharedModule } from './shared/shared.module';

initializeApp(environment.firebase);

@NgModule({
    declarations: [
        AppComponent, 
        ToasterComponent,
        ConfimationDialogueComponent,
    ],
    imports: [
        AppRoutingModule, 
        AppLayoutModule, 
        LayoutModule, 
        ToastModule,
        ConfirmDialogModule,
        SharedModule
    ],
    providers: [ 
        { provide: LocationStrategy, useClass: PathLocationStrategy }, 
        MessageService, 
        ConfirmationService,
        DatePipe,
        CurrencyPipe
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
